import {} from './types.js'

export default {
  isModalOpen(state, getters) {
    return params => getters.findModal(params) != undefined
  },
  findModal(state) {
    return params =>
      [...state.modals]
        .reverse()
        .find(modal => modal[params.type] === params.value)
  },
  getModals(state) {
    return state.modals
  },
  getLastModal(state) {
    let modals = state.modals
    return modals[modals.length - 1]
  },
}
